import { useDispatch, useSelector } from "react-redux";

import { MARKER_FOCUS_ZOOM_LEVEL } from "@/constants/map";
import { RootState } from "@/store";
import {
  addPlaceCoordinateTemp,
  removeItemCoordinateTemp,
  updateCoordinateItemTemp
} from "@/store/slice/spatialSlice";
import { toggleAllowPinMarker } from "@/store/slice/uiSlice";
import { MarkerPinItem } from "@/types/map";
import { PlaceItem } from "@/types/place";

import { useMap } from "../map/core/useMapContext";

export interface PlaceOption {
  id: number;
  name: string;
  lat: number;
  lng: number;
}

const useCatchmentPlaceSection = () => {
  const { handleRemoveMarker, map } = useMap();
  const dispatch = useDispatch();

  const { catchmentSettingsTemp } = useSelector(
    (state: RootState) => state.spatial
  );
  const { allowPinMarker } = useSelector((state: RootState) => state.ui);

  const handlePinMaker = () => {
    dispatch(toggleAllowPinMarker(!allowPinMarker));
  };

  const handleSelectPlace = (option: PlaceItem | null) => {
    if (!option) return;
    dispatch(
      addPlaceCoordinateTemp({
        lng: option.coordinates.longitude,
        lat: option.coordinates.latitude,
        locationName: option.name,
        id: ""
      })
    );
    if (!map) return;
    map.flyTo({
      center: [option.coordinates.longitude, option.coordinates.latitude], // or [longitude, latitude] directly
      zoom: MARKER_FOCUS_ZOOM_LEVEL, // Adjust zoom level as needed
      duration: 2000 // Animation duration in milliseconds (optional)
      // other flyTo options: https://maplibre.org/maplibre-gl-js-docs/api/map/#flyto
    });
  };

  const handleRemoveItem = (item: MarkerPinItem) => {
    dispatch(removeItemCoordinateTemp(item.id));
    const markerIndex: number =
      catchmentSettingsTemp.placeCoordinates?.findIndex(
        (place) => place.id === item.id
      ) ?? -1;
    if (markerIndex === -1) return;
    handleRemoveMarker(markerIndex);
  };

  const handleChangeNameMarker = (text: string, item: MarkerPinItem) => {
    dispatch(updateCoordinateItemTemp({ ...item, locationName: text }));
  };

  return {
    handleSelectPlace,
    handlePinMaker,
    handleRemoveItem,
    handleChangeNameMarker
  };
};

export default useCatchmentPlaceSection;
